// routes/_app.artwork.$id.relevant.tsx
import { dynamic } from 'src/utils/ssr'
import {
  DEFAULT_TITLE,
  staticMeta,
  staticMetaLoader,
} from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/_app.artwork.$id.relevant'

const getClientModule = () =>
  import('src/clientRoutes/_app.artwork.$id.relevant')

export const handle = {
  name: 'artwork-relevant-artworks',
  track: { scene: 'artwork-relevant' },
  showAppNav: true,
}

export function loader({ request }: Route.LoaderArgs) {
  return staticMetaLoader({
    requestUrl: request.url,
    title: DEFAULT_TITLE,
  })
}

export function meta({ loaderData }: Route.MetaArgs) {
  return staticMeta(loaderData)
}

export default dynamic(getClientModule, { ssr: false })
